<template>
	<b-modal id="complete-maintenance" :title="title" ok-title="Proceed" ref="modal" @ok="handleOk"
		:cancel-disabled="disableConfirmButtons" :ok-disabled="disableConfirmButtons" :no-close-on-backdrop="true">

		<loading :active.sync="isLoading" loader="spinner" color="#20A8D8" :is-full-page="false" />

		<div class="my-2">
			Are you sure you want to mark maintenance <b>{{ this.selMaintenance.maintenanceId }}</b> as <b>complete</b>?
		</div>
		<div class="message-note mt-2">
			NOTE: This action cannot be undone and you will be unable to edit any data.
		</div>
	</b-modal>
</template>

<script>
// Utils
import { DateUtil } from '@/utils/dateutil';

// API
import maintenanceApi from '@/api/maintenanceApi';

// Others
import EventBus from '@/shared/event-bus';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _ from 'lodash';

export default {
	name: 'complete-maintenance',
	components: {
		Loading,
	},
	data() {
		return {
			selMaintenance: {},
			loggedUser: this.$store.getters.loggedUser,
			// Check for loader
			isLoading: false,
		};
	},
	computed: {
		title() {
			return 'Complete Maintenance';
		},
		disableConfirmButtons() {
			return this.isLoading;
		},
	},
	mounted() {
		EventBus.$on('onUpdateMaintenance', (maintenance) => {
			if (!_.isEmpty(maintenance)) {
				this.selMaintenance = maintenance;
			}
		});
	},
	methods: {
		async handleOk(evt) {
			// Prevent modal from closing
			evt.preventDefault();

			// show loading indicator
			this.isLoading = true;

			// update fields
			this.selMaintenance.dateUpdated = DateUtil.getCurrentTimestamp();
			this.selMaintenance.updatedBy = this.loggedUser.id;

			let maintenanceId = this.selMaintenance.maintenanceId;
			try {
				let { data } = await maintenanceApi.completeMaintenance(
					this.selMaintenance,
					this.loggedUser.id
				);

				if (data.isSuccess) {
					this.$toaster.success(`Maintenance "${maintenanceId}" was completed successfully.`);
					EventBus.$emit('onCloseSaveMaintenance', data.maintenance);
					this.$refs.modal.hide();

				} else {
					this.$toaster.warning(data.message);
				}

			} catch (error) {
				this.$toaster.error(`Error completing maintenance "${maintenanceId}". Please try again.`);
			}

			// hide loading indicator
			this.isLoading = false;
		},
	},
	beforeDestroy() {
		EventBus.$off('onUpdateMaintenance');
	},
};
</script>

<style scoped>
.message-note {
	font-size: 12px;
	color: #f44335;
	font-style: normal;
}
</style>

